// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-page {
  display: flex;
}
@media (max-width: 960px) {
  .order-page {
    flex-direction: column;
  }
}
.order-page .left-block {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 40px;
  width: 50%;
  padding: 40px 70px 40px 70px;
}
@media (max-width: 960px) {
  .order-page .left-block {
    width: auto;
  }
}
@media (max-width: 480px) {
  .order-page .left-block {
    padding: 40px 35px 40px 35px;
  }
}
.order-page .left-block .top-block {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 14px;
}
.order-page .left-block .top-block .order-number {
  color: #062743;
  font-family: Inter;
  font-size: 26px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
.order-page .left-block .top-block .thank-you-text {
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.order-page .left-block .statuses-block {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 14px;
}
.order-page .left-block .statuses-block .status-line {
  display: flex;
  gap: 15px;
}
.order-page .left-block .statuses-block .status-line:not(:last-child) .left .vertical-line {
  width: 1px;
  height: 32px;
  background: #D9D9D9;
}
.order-page .left-block .statuses-block .status-line .left {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
}
.order-page .left-block .statuses-block .status-line .right {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}
.order-page .left-block .statuses-block .status-line .right .status-title {
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.order-page .left-block .statuses-block .status-line .right .status-description {
  color: #686868;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  margin-bottom: 10px;
}
.order-page .left-block .statuses-block .status-line .right .status-date {
  color: #646464;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.order-page .left-block .tracking-block {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 15px;
}
.order-page .left-block .tracking-block .track {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 5px;
}
.order-page .left-block .tracking-block .track .title {
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
.order-page .left-block .tracking-block .track .link {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.order-page .left-block .tracking-block .track .link a {
  font-weight: 600;
}
.order-page .left-block .bottom-block {
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: center;
  justify-content: center;
  border: 1px solid #D9D9D9;
  background: #FFF;
  padding: 20px;
  max-width: 100%;
}
@media (max-width: 960px) {
  .order-page .left-block .bottom-block {
    gap: 20px;
  }
}
.order-page .left-block .bottom-block .text {
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
}
.order-page .right-block {
  background: #FAFAFA;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 38px;
  width: 50%;
  padding: 40px 70px 40px 70px;
}
@media (max-width: 960px) {
  .order-page .right-block {
    width: auto;
  }
}
@media (max-width: 480px) {
  .order-page .right-block {
    padding: 40px 35px 40px 35px;
  }
}
.order-page .right-block .top-block .title {
  color: #062743;
  font-family: Inter;
  font-size: 26px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
.order-page .right-block .products-block {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 38px;
}
.order-page .right-block .products-block .category-block {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 38px;
}
.order-page .right-block .products-block .category-block .category-name {
  color: #686868;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.order-page .right-block .products-block .category-block .category-name .category-description {
  display: block;
  color: #686868;
  font-family: Inter;
  font-size: 14px;
  font-style: italic;
  font-weight: 500;
  line-height: 24px;
}
.order-page .right-block .products-block .category-block .products-list {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 38px;
}
@media (max-width: 560px) {
  .order-page .right-block .products-block .category-block .products-list {
    gap: 25px;
  }
}
.order-page .right-block .products-block .category-block .products-list .product {
  display: flex;
  align-items: center;
  gap: 14px;
}
.order-page .right-block .products-block .category-block .products-list .product .image {
  min-width: 100px;
  height: 95.573px;
  border: 0.5px solid #686868;
  background: #FFF;
  position: relative;
}
.order-page .right-block .products-block .category-block .products-list .product .image img {
  width: 100px;
  height: 95.573px;
  object-fit: cover;
}
.order-page .right-block .products-block .category-block .products-list .product .image .qty-circle {
  position: absolute;
  top: 0;
  right: 0;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #D9D9D9;
  transform: translate(50%, -50%);
  color: #062743;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
}
.order-page .right-block .products-block .category-block .products-list .product .full-name {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  width: 100%;
}
.order-page .right-block .products-block .category-block .products-list .product .full-name .title {
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.order-page .right-block .products-block .category-block .products-list .product .full-name .variation-title {
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.order-page .right-block .products-block .category-block .products-list .product .price {
  margin-left: auto;
  min-width: -moz-fit-content;
  min-width: fit-content;
  display: none;
}
@media (max-width: 560px) {
  .order-page .right-block .products-block .category-block .products-list .product .price.mobile-only {
    display: block;
  }
}
@media (min-width: 561px) {
  .order-page .right-block .products-block .category-block .products-list .product .price.web-only {
    display: block;
  }
}
.order-page .right-block .products-block .category-block .products-list .product .price .value {
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.order-page .right-block .products-block .category-block .products-list .product .price .value .crossed-price {
  padding-right: 5px;
  font-weight: 500;
  text-decoration: line-through;
}
.order-page .right-block .hr-line {
  height: 1px;
  background: #D9D9D9;
}
.order-page .right-block .subtotal-block {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 9px;
}
.order-page .right-block .subtotal-block .line {
  display: flex;
  justify-content: space-between;
}
.order-page .right-block .subtotal-block .line .title {
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.order-page .right-block .subtotal-block .line .value {
  color: #000;
  text-align: right;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.order-page .right-block .total-block .line {
  display: flex;
  justify-content: space-between;
}
.order-page .right-block .total-block .line .title {
  color: #000;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
.order-page .right-block .total-block .line .value {
  color: #000;
  text-align: right;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/order-page.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;AACD;AACC;EAHD;IAIE,sBAAA;EAEA;AACF;AAAC;EACC,aAAA;EACA,eAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,4BAAA;AAEF;AAAE;EARD;IASE,WAAA;EAGD;AACF;AADE;EAZD;IAaE,4BAAA;EAID;AACF;AAFE;EACC,aAAA;EACA,eAAA;EACA,sBAAA;EACA,SAAA;AAIH;AAFG;EACC,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAIJ;AADG;EACC,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAGJ;AACE;EACC,aAAA;EACA,eAAA;EACA,sBAAA;EACA,SAAA;AACH;AACG;EACC,aAAA;EACA,SAAA;AACJ;AAGM;EACC,UAAA;EACA,YAAA;EACA,mBAAA;AADP;AAMI;EACC,aAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;AAJL;AAOI;EACC,aAAA;EACA,eAAA;EACA,sBAAA;AALL;AAOK;EACC,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AALN;AAQK;EACC,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AANN;AASK;EACC,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAPN;AAaE;EACC,aAAA;EACA,eAAA;EACA,sBAAA;EACA,SAAA;AAXH;AAaG;EACC,aAAA;EACA,eAAA;EACA,sBAAA;EACA,QAAA;AAXJ;AAaI;EACC,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAXL;AAcI;EACC,aAAA;EACA,eAAA;EACA,mBAAA;AAZL;AAcK;EACC,gBAAA;AAZN;AAkBE;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;AAhBH;AAkBG;EAXD;IAYE,SAAA;EAfF;AACF;AAiBG;EACC,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAfJ;AAoBC;EACC,mBAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,4BAAA;AAlBF;AAoBE;EATD;IAUE,WAAA;EAjBD;AACF;AAmBE;EAbD;IAcE,4BAAA;EAhBD;AACF;AAmBG;EACC,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAjBJ;AAqBE;EACC,aAAA;EACA,eAAA;EACA,sBAAA;EACA,SAAA;AAnBH;AAqBG;EACC,aAAA;EACA,eAAA;EACA,sBAAA;EACA,SAAA;AAnBJ;AAqBI;EACC,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAnBL;AAqBK;EACC,cAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAnBN;AAuBI;EACC,aAAA;EACA,eAAA;EACA,sBAAA;EACA,SAAA;AArBL;AAuBK;EAND;IAOE,SAAA;EApBJ;AACF;AAsBK;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AApBN;AAsBM;EACC,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;AApBP;AAsBO;EACC,YAAA;EACA,gBAAA;EACA,iBAAA;AApBR;AAuBO;EACC,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,+BAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AArBR;AAyBM;EACC,aAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;AAvBP;AAyBO;EACC,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAvBR;AA0BO;EACC,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAxBR;AA4BM;EACC,iBAAA;EACA,2BAAA;EAAA,sBAAA;EACA,aAAA;AA1BP;AA4BO;EACC;IACC,cAAA;EA1BP;AACF;AA6BO;EACC;IACC,cAAA;EA3BP;AACF;AA8BO;EACC,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA5BR;AA8BQ;EACC,kBAAA;EACA,gBAAA;EACA,6BAAA;AA5BT;AAqCE;EACC,WAAA;EACA,mBAAA;AAnCH;AAsCE;EACC,aAAA;EACA,eAAA;EACA,sBAAA;EACA,QAAA;AApCH;AAsCG;EACC,aAAA;EACA,8BAAA;AApCJ;AAsCI;EACC,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AApCL;AAuCI;EACC,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AArCL;AA2CG;EACC,aAAA;EACA,8BAAA;AAzCJ;AA2CI;EACC,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAzCL;AA4CI;EACC,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA1CL","sourcesContent":[".order-page {\n\tdisplay: flex;\n\n\t@media (max-width: 960px) {\n\t\tflex-direction: column;\n\t}\n\n\t.left-block {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tflex-direction: column;\n\t\tgap: 40px;\n\t\twidth: 50%;\n\t\tpadding: 40px 70px 40px 70px;\n\n\t\t@media (max-width: 960px) {\n\t\t\twidth: auto;\n\t\t}\n\n\t\t@media (max-width: 480px) {\n\t\t\tpadding: 40px 35px 40px 35px;\n\t\t}\n\n\t\t.top-block {\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: wrap;\n\t\t\tflex-direction: column;\n\t\t\tgap: 14px;\n\n\t\t\t.order-number {\n\t\t\t\tcolor: #062743;\n\t\t\t\tfont-family: Inter;\n\t\t\t\tfont-size: 26px;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tline-height: 24px;\n\t\t\t}\n\n\t\t\t.thank-you-text {\n\t\t\t\tcolor: #000;\n\t\t\t\tfont-family: Inter;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tline-height: 24px;\n\t\t\t}\n\t\t}\n\n\t\t.statuses-block {\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: wrap;\n\t\t\tflex-direction: column;\n\t\t\tgap: 14px;\n\n\t\t\t.status-line {\n\t\t\t\tdisplay: flex;\n\t\t\t\tgap: 15px;\n\n\t\t\t\t&:not(:last-child) {\n\t\t\t\t\t.left {\n\t\t\t\t\t\t.vertical-line {\n\t\t\t\t\t\t\twidth: 1px;\n\t\t\t\t\t\t\theight: 32px;\n\t\t\t\t\t\t\tbackground: #D9D9D9;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.left {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-wrap: wrap;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\talign-items: center;\n\t\t\t\t}\n\n\t\t\t\t.right {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-wrap: wrap;\n\t\t\t\t\tflex-direction: column;\n\n\t\t\t\t\t.status-title {\n\t\t\t\t\t\tcolor: #000;\n\t\t\t\t\t\tfont-family: Inter;\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\tfont-style: normal;\n\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\tline-height: 24px;\n\t\t\t\t\t}\n\n\t\t\t\t\t.status-description {\n\t\t\t\t\t\tcolor: #686868;\n\t\t\t\t\t\tfont-family: Inter;\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\tfont-style: normal;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tline-height: 14px;\n\t\t\t\t\t\tmargin-bottom: 10px;\n\t\t\t\t\t}\n\n\t\t\t\t\t.status-date {\n\t\t\t\t\t\tcolor: #646464;\n\t\t\t\t\t\tfont-family: Inter;\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tfont-style: normal;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tline-height: 24px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.tracking-block {\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: wrap;\n\t\t\tflex-direction: column;\n\t\t\tgap: 15px;\n\n\t\t\t.track {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-wrap: wrap;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 5px;\n\n\t\t\t\t.title {\n\t\t\t\t\tcolor: #000;\n\t\t\t\t\tfont-family: Inter;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tline-height: 24px;\n\t\t\t\t}\n\n\t\t\t\t.link {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-wrap: wrap;\n\t\t\t\t\talign-items: center;\n\n\t\t\t\t\ta {\n\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.bottom-block {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tgap: 10px;\n\t\t\ttext-align: center;\n\t\t\tjustify-content: center;\n\t\t\tborder: 1px solid #D9D9D9;\n\t\t\tbackground: #FFF;\n\t\t\tpadding: 20px;\n\t\t\tmax-width: 100%;\n\n\t\t\t@media (max-width: 960px) {\n\t\t\t\tgap: 20px;\n\t\t\t}\n\n\t\t\t.text {\n\t\t\t\tcolor: #000;\n\t\t\t\tfont-family: Inter;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tline-height: 24px;\n\t\t\t\ttext-align: left;\n\t\t\t}\n\t\t}\n\t}\n\n\t.right-block {\n\t\tbackground: #FAFAFA;\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tflex-direction: column;\n\t\tgap: 38px;\n\t\twidth: 50%;\n\t\tpadding: 40px 70px 40px 70px;\n\n\t\t@media (max-width: 960px) {\n\t\t\twidth: auto;\n\t\t}\n\n\t\t@media (max-width: 480px) {\n\t\t\tpadding: 40px 35px 40px 35px;\n\t\t}\n\n\t\t.top-block {\n\t\t\t.title {\n\t\t\t\tcolor: #062743;\n\t\t\t\tfont-family: Inter;\n\t\t\t\tfont-size: 26px;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tline-height: 24px;\n\t\t\t}\n\t\t}\n\n\t\t.products-block {\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: wrap;\n\t\t\tflex-direction: column;\n\t\t\tgap: 38px;\n\n\t\t\t.category-block {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-wrap: wrap;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 38px;\n\n\t\t\t\t.category-name {\n\t\t\t\t\tcolor: #686868;\n\t\t\t\t\tfont-family: Inter;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tline-height: 24px;\n\n\t\t\t\t\t.category-description {\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\tcolor: #686868;\n\t\t\t\t\t\tfont-family: Inter;\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\tfont-style: italic;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tline-height: 24px;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.products-list {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-wrap: wrap;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\tgap: 38px;\n\n\t\t\t\t\t@media(max-width: 560px) {\n\t\t\t\t\t\tgap: 25px;\n\t\t\t\t\t}\n\n\t\t\t\t\t.product {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tgap: 14px;\n\n\t\t\t\t\t\t.image {\n\t\t\t\t\t\t\tmin-width: 100px;\n\t\t\t\t\t\t\theight: 95.573px;\n\t\t\t\t\t\t\tborder: 0.5px solid #686868;\n\t\t\t\t\t\t\tbackground: #FFF;\n\t\t\t\t\t\t\tposition: relative;\n\n\t\t\t\t\t\t\timg {\n\t\t\t\t\t\t\t\twidth: 100px;\n\t\t\t\t\t\t\t\theight: 95.573px;\n\t\t\t\t\t\t\t\tobject-fit: cover;\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t.qty-circle {\n\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\t\twidth: 25px;\n\t\t\t\t\t\t\t\theight: 25px;\n\t\t\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\t\t\tbackground-color: #D9D9D9;\n\t\t\t\t\t\t\t\ttransform: translate(50%, -50%);\n\t\t\t\t\t\t\t\tcolor: #062743;\n\t\t\t\t\t\t\t\tfont-family: Inter;\n\t\t\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\t\t\tfont-style: normal;\n\t\t\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\t\t\tline-height: 24px;\n\t\t\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.full-name {\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tflex-wrap: wrap;\n\t\t\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t\t\twidth: 100%;\n\n\t\t\t\t\t\t\t.title {\n\t\t\t\t\t\t\t\tcolor: #000;\n\t\t\t\t\t\t\t\tfont-family: Inter;\n\t\t\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\t\t\tfont-style: normal;\n\t\t\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\t\t\tline-height: 24px;\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t.variation-title {\n\t\t\t\t\t\t\t\tcolor: #000;\n\t\t\t\t\t\t\t\tfont-family: Inter;\n\t\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\t\tfont-style: normal;\n\t\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t\t\tline-height: 24px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.price {\n\t\t\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\t\t\tmin-width: fit-content;\n\t\t\t\t\t\t\tdisplay: none;\n\n\t\t\t\t\t\t\t@media (max-width: 560px) {\n\t\t\t\t\t\t\t\t&.mobile-only {\n\t\t\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t@media (min-width: 561px) {\n\t\t\t\t\t\t\t\t&.web-only {\n\t\t\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t.value {\n\t\t\t\t\t\t\t\tcolor: #000;\n\t\t\t\t\t\t\t\tfont-family: Inter;\n\t\t\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\t\t\tfont-style: normal;\n\t\t\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\t\t\tline-height: 24px;\n\n\t\t\t\t\t\t\t\t.crossed-price {\n\t\t\t\t\t\t\t\t\tpadding-right: 5px;\n\t\t\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t\t\t\ttext-decoration: line-through;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.hr-line {\n\t\t\theight: 1px;\n\t\t\tbackground: #D9D9D9;\n\t\t}\n\n\t\t.subtotal-block {\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: wrap;\n\t\t\tflex-direction: column;\n\t\t\tgap: 9px;\n\n\t\t\t.line {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\n\t\t\t\t.title {\n\t\t\t\t\tcolor: #000;\n\t\t\t\t\tfont-family: Inter;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tline-height: 24px;\n\t\t\t\t}\n\n\t\t\t\t.value {\n\t\t\t\t\tcolor: #000;\n\t\t\t\t\ttext-align: right;\n\t\t\t\t\tfont-family: Inter;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\tline-height: 24px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.total-block {\n\t\t\t.line {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\n\t\t\t\t.title {\n\t\t\t\t\tcolor: #000;\n\t\t\t\t\tfont-family: Inter;\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tline-height: 24px;\n\t\t\t\t}\n\n\t\t\t\t.value {\n\t\t\t\t\tcolor: #000;\n\t\t\t\t\ttext-align: right;\n\t\t\t\t\tfont-family: Inter;\n\t\t\t\t\tfont-size: 24px;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\tline-height: 24px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
